import type { ThreadMessage } from "@assistant-ui/react";

export interface StoredMessage {
  role: "user" | "assistant";
  content: string;
}

export function convertMessagesToStorageFormat(messages: readonly ThreadMessage[]): string {
  const storedMessages: StoredMessage[] = messages
    .filter((msg) => msg.role === "user" || msg.role === "assistant")
    .map((msg) => {
      const textContent = msg.content
        .filter((part) => part.type === "text")
        .map((part) => (part.type === "text" ? part.text : ""))
        .join("\n");

      return {
        role: msg.role as "user" | "assistant",
        content: textContent,
      };
    });

  return JSON.stringify(storedMessages);
}

export function extractTextFromMessage(message: ThreadMessage): string {
  return message.content
    .filter((part) => part.type === "text")
    .map((part) => (part.type === "text" ? part.text : ""))
    .join(" ")
    .trim();
}

export function truncateToLines(text: string, maxLines: number): string {
  const lines = text.split("\n");
  if (lines.length <= maxLines) {
    return text;
  }
  return lines.slice(0, maxLines).join("\n") + "...";
}
